import React, { useEffect } from 'react';
import IsInRange from '../Base/Sensors/isInRange';

const List = (props) => {
  useEffect(() => {
    props.handleLetterChange(props.letter);
  }, [props.isInRange]);

  return (
    <div className="ao-list__wrapper" id={`${props.letter.toLowerCase()}`}>
      <h2 className="ao-list__wrapper__letter">{props.letter}</h2>
      <ul className="ao-list__wrapper__list">
        {props.list.map((item, key) => (
          <li key={key}>
            <a href={item.Url}>{item.Name}</a>
          </li>
        ))}
      </ul>
      <a
        className="ao-list__wrapper__back"
        href={`#nav-${props.letter.toLowerCase()}`}
      >
        <span>Tillbaka till navigering</span>
      </a>
    </div>
  );
};

export default IsInRange(List);
